import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { colors } from "../../assets/styles";

const fadeInAnimation = keyframes`${fadeIn}`;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const P = styled.p`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? colors.textColorBlackTow
      : colors.textColorBlackFor};
`;

export const Ul = styled.ul``;

export const Li = styled.li`
  color: ${(props) =>
    props.theme.isDarkTheme
      ? colors.textColorBlackTow
      : colors.textColorBlackFor};
      text-align: justify;
`;

export const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 10px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? colors.textColorBlackSeven
      : colors.textColorBlackFor};
`;
